import type { IFilterPanelBaseFilterDeps, IFilterPanelBaseFilterModel } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/filters";
import { FilterPanelBaseFilter } from "app/pages/sales-intelligence/modules/advanced-search-filtering/models/BaseFilter";
import type {
    IIabCategoriesDescriptionDto,
    IIabCategoryItemDescriptionDto,
} from "app/pages/sales-intelligence/modules/find-apps-filters/types/description.dto";
import type { IIabCategoriesFilterDto } from "app/pages/sales-intelligence/store/find-apps/types";

export default class IabCategoriesFilter
    extends FilterPanelBaseFilter<IIabCategoriesFilterDto, readonly IIabCategoryItemDescriptionDto[]>
    implements IFilterPanelBaseFilterModel<IIabCategoriesFilterDto, readonly IIabCategoryItemDescriptionDto[]>
{
    constructor({ options }: IFilterPanelBaseFilterDeps<IIabCategoriesFilterDto, IIabCategoriesDescriptionDto>) {
        const { categories } = options;

        super({ options: categories });
    }
}
